const keys = {
    GET_ACTIVE_PLAN_SUBSCRIPTION: (page_id: string) => `/active-plan-subscriptions/${page_id}`,
    GET_PLAN_SUBSCRIPTION: (page_id: string) => `/plan-subscriptions/${page_id}`,
    POST_ACTIVE_RESERVE_SUBSCRIPTION: (page_id: string, subscription_id: string) =>
        `/plans/activate-reserved-subscription/${page_id}/${subscription_id}`,
    GET_SUBSCRIPTION_REFUND: (page_id: string) => `/plans/cancel-subscription-refund-amount/${page_id}`
};

export default keys;

